import { Formik } from 'formik';
import { Button, Header, Segment, Form } from 'semantic-ui-react';
import { store, useStore } from '../../app/stores/store';
import { v4 as uuid } from 'uuid';
import * as Yup from 'yup';
import { observer } from 'mobx-react-lite';
import {
  Department,
  DepartmentInitialState,
} from './../../app/models/department';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { useEffect, useState } from 'react';
import sendRespectiveEmail from '../../app/models/EmailNew';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';
import MyTextInput from '../../app/common/form/MyTextInput';
import './../../app/layout/styles.css';

interface Props {
  isEdit?: boolean;
}

function DepartmentMasterForm({ isEdit }: Props) {
  const {
    departmentStore,
    modalStore,
    userStore,
    RolesAndPermissionsIDStore,
    dashboardStore,
    commonStore,
  } = useStore();
  const [departmentData, setDepartmentData] = useState<Department>(
    DepartmentInitialState,
  );
  const { createDepartment, updateDepartment, selectedDepartment } =
    departmentStore;
  const { loadDepartments, departmentRegistry } = departmentStore;
  // const [errorType, setErrorType] = useState<string>('');
  // const [errortype, setErrortype] = useState<string>('');
  // const [emailError, setEmailError] = useState<string>('');
  // const [phoneError, setPhoneError] = useState<string>('');
  useEffect(() => {
    if (departmentRegistry.size <= 1) loadDepartments();
  }, [departmentRegistry.size, loadDepartments]);
  useEffect(() => {
    // updating
    if (
      selectedDepartment?.id !== undefined &&
      dashboardStore.dashboard.formikClearFormBool === true
    ) {
      const newArr = {
        ...selectedDepartment,
      };
      setDepartmentData(newArr);
    }
    // eslint-disable-next-line
  }, [selectedDepartment]);
  ////////////////////////////// Form Submit
  const handleSubmit = (values: Department) => {
    if (values.id === '') {
      const ID = uuid();
      const newDepartmentData = {
        ...values,
        id: ID,
      };
      const newRoleArr = {
        id: uuid(),
        itemId: ID,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };

      createDepartment(newDepartmentData); //create  data   api
      sendRespectiveEmail(
        'created',
        newDepartmentData.department_Name,
        'Created New Department',
        '',
      ); //email
      dashboardStore.dashboard.formikClearFormBool = false; //resetting data
      store.departmentStore.selectedDepartment = undefined; //resetting data
      RolesAndPermissionsIDStore.createRoleID(newRoleArr); //for roles and permissions
    } else {
      updateDepartment(values); //update  data   api
      sendRespectiveEmail(
        'edited',
        values.department_Name,
        'Edited Department',
        '',
      ); //email
      dashboardStore.dashboard.formikClearFormBool = false; //resetting data
      store.departmentStore.selectedDepartment = undefined; //resetting data
    }
    modalStore.closeModal(); //closing modal
    setDepartmentData(DepartmentInitialState); //resetting data
  };

  ////////////////////handle Change
  // const handleChange = (e: any, data: any) => {
  //   const newArr = {
  //     ...departmentData,
  //     [e.target.name]: e.target.value,
  //   };
  //   setDepartmentData(newArr);
  //   const NameCheck = departmentitemsByDate.some(function (el: any) {
  //     return (
  //       el.department_Name.trim().toLowerCase() ===
  //       data.value.trim().toLowerCase()
  //     );
  //   });
  //   const CodeCheck = departmentitemsByDate.some(function (el: any) {
  //     return (
  //       el.department_Code.trim().toLowerCase() ===
  //       data.value.trim().toLowerCase()
  //     );
  //   });
  //   const EmailCheck = departmentitemsByDate.some(function (el: any) {
  //     return (
  //       el.department_Email.trim().toLowerCase() ===
  //       data.value.trim().toLowerCase()
  //     );
  //   });
  //   const NumberCheck = departmentitemsByDate.some(function (el: any) {
  //     return (
  //       el.department_Phone_Number.trim().toLowerCase() ===
  //       data.value.trim().toLowerCase()
  //     );
  //   });
  //   setErrorType(NameCheck ? 'SameName' : '');
  //   setErrortype(CodeCheck ? 'SameCode' : '');
  //   setEmailError(EmailCheck ? 'SameEmail' : '');
  //   setPhoneError(NumberCheck ? 'SamePhoneNumber' : '');
  // };
  ////////////////////handle Cancel
  const handleCancel = () => {
    setDepartmentData(DepartmentInitialState); //resetting data
    modalStore.closeModal(); //closing modal
    dashboardStore.dashboard.formikClearFormBool = false; //resetting data
    store.departmentStore.selectedDepartment = undefined; //resetting data
  };

  return (
    <>
      <div
        id="parent-grid-vault"
        className={
          isEdit
            ? 'editScreen largeScreen smallScreen'
            : 'largeScreen smallScreen'
        }
      >
        {dashboardStore.dashboard.loadingdata === 'loading' && (
          <LoadingComponent />
        )}
        {dashboardStore.dashboard.loadingdata !== 'loading' &&
          !commonStore.filterModeOne?.includes('DMRB01') && (
            <UnauthorizedMessage />
          )}
        {dashboardStore.dashboard.loadingdata !== 'loading' &&
          commonStore.filterModeOne?.includes('DMRB01') && (
            <Segment clearing className="vault-form-segment" responsive={true}>
              <Header
                icon="edit"
                size="huge"
                dividing
                as="h1"
                content={
                  (
                    userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                      ?.DMRL01 as any
                  )?.[`${commonStore.language.key}`]
                } //'Department Master'
                sub
                color="grey"
              />
              <Header />
              <Formik
                initialValues={departmentData}
                enableReinitialize={true}
                onSubmit={(values, { resetForm }) => {
                  handleSubmit(values);
                  resetForm();
                }}
                validationSchema={Yup.object({
                  department_Name: Yup.string()
                    .min(2, 'Please enter atleast 2 characters')
                    .max(150, 'Please enter atmost 150 characters')
                    .required('Please enter a name')
                    .matches(
                      /^[aA-zZ\s]+$/,
                      'Only alphabets are allowed for this field ',
                    ),
                  department_Email: Yup.string()
                    .email('Invalid email format')
                    .required('Please enter a email'),
                  //  department_Description: Yup.string().min(2).max(150).required("Please enter a description"),
                  department_Phone_Number: Yup.string()
                    .min(9, 'Please enter atleast 9 digits')
                    .max(16, 'Phone number must be atmost 16 characters')
                    .matches(
                      /^(\+|\d)[0-9]{9,16}$/,
                      'Please enter valid phone number',
                    )
                    .required('Please enter phone number'),
                  department_Code: Yup.string()
                    .min(2, 'Please enter atleast 2 characters')
                    .max(10, 'Please enter atmost 10 characters')
                    .required('Please enter a code'),
                })}
              >
                {({ handleSubmit, isSubmitting }) => (
                  <Form
                    className="ui form error"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                  >
                    <Form.Group widths="equal">
                      <MyTextInput
                        label={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRL02 as any
                          )?.[`${commonStore.language.key}`]
                        } //Department Name
                        // id="form-input-control-error-email"
                        name="department_Name"
                        // error={
                        //   errorType === 'SameName'
                        //     ? departmenterrorMessageText
                        //     : errorType === 'EmptyName'
                        //     ? errorEmptyText
                        //     : null
                        // }
                        // control={Input}
                        // value={departmentData.department_Name}
                        placeholder={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRTB01 as any
                          )?.[`${commonStore.language.key}`]
                        } //"Enter Department Name"
                        touched
                        mandatory
                        // onChange={handleChange}
                      />
                      <MyTextInput
                        label={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRL03 as any
                          )?.[`${commonStore.language.key}`]
                        } //Department Code
                        // id="form-input-control-error-email"
                        name="department_Code"
                        // error={
                        //   errortype === 'SameCode'
                        //     ? departmentCodeerrorMessageText
                        //     : errortype === 'EmptyName'
                        //     ? errorEmptyText
                        //     : null
                        // }
                        // control={Input}
                        // value={departmentData.department_Code}
                        placeholder={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRTB02 as any
                          )?.[`${commonStore.language.key}`]
                        } //"Enter Department Code"
                        // onChange={handleChange}
                        touched
                        mandatory
                      />
                      <MyTextInput
                        label={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRL04 as any
                          )?.[`${commonStore.language.key}`]
                        } //Description
                        // id="form-input-control-error-email"
                        name="department_Description"
                        // control={Input}
                        // value={departmentData.department_Description}
                        placeholder={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRTB03 as any
                          )?.[`${commonStore.language.key}`]
                        } //"Enter Department Description"
                        // onChange={handleChange}
                      />
                    </Form.Group>
                    <Form.Group widths="equal">
                      <MyTextInput
                        label={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRL05 as any
                          )?.[`${commonStore.language.key}`]
                        } //Department Email
                        // id="form-input-control-error-email"
                        name="department_Email"
                        type="email"
                        // error={
                        //   emailError === 'SameEmail'
                        //     ? departmentEmailerrorMessageText
                        //     : emailError === 'EmptyEmail'
                        //     ? errorEmptyText
                        //     : null
                        // }
                        // control={Input}
                        // value={departmentData.department_Email}
                        placeholder={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRTB04 as any
                          )?.[`${commonStore.language.key}`]
                        } //"Enter Department email"
                        // onChange={handleChange}
                        touched
                        mandatory
                      />
                      <MyTextInput
                        label={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRL06 as any
                          )?.[`${commonStore.language.key}`]
                        }
                        // id="form-input-control-error-email"
                        name="department_Phone_Number"
                        // type="number"
                        // pattern="{10}[0-9]{16}"
                        // error={
                        //   phoneError === 'SamePhoneNumber'
                        //     ? departmentPhoneerrorMessageText
                        //     : phoneError === 'EmptyName'
                        //     ? errorEmptyText
                        //     : null
                        // }
                        // control={Input}
                        // value={departmentData.department_Phone_Number}
                        placeholder={
                          (
                            userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                              ?.DMRTB05 as any
                          )?.[`${commonStore.language.key}`]
                        } //"Enter Phone Number"
                        // onChange={handleChange}
                        touched
                        mandatory
                      />
                    </Form.Group>
                    <Button.Group floated="right">
                      {commonStore.filterModeTwo?.includes('DMRB02') ? (
                        <></>
                      ) : (
                        <Button
                          onClick={handleCancel}
                          type="reset"
                          className={
                            commonStore.filterModeZero.includes('DMRB02')
                              ? 'component-isDisabled'
                              : ''
                          }
                          //Cancel
                        >
                          {' '}
                          {
                            (
                              userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                                ?.DMRB01 as any
                            )?.[`${commonStore.language.key}`]
                          }{' '}
                        </Button>
                      )}

                      {commonStore.filterModeTwo?.includes('DMRB02') ||
                      commonStore.filterModeTwo?.includes('DMRB03') ? (
                        <></>
                      ) : (
                        <Button.Or
                          text={
                            (
                              userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                                ?.DMRB02 as any
                            )?.[`${commonStore.language.key}`]
                          }
                        />
                      )}

                      {commonStore.filterModeTwo?.includes('DMRB03') ? (
                        <></>
                      ) : (
                        <Button
                          loading={isSubmitting}
                          className={
                            commonStore.filterModeZero.includes('DMRB03')
                              ? 'component-isDisabled'
                              : ''
                          }
                          // disabled={
                          //   !departmentData.department_Name ||
                          //   !departmentData.department_Code ||
                          //   !departmentData.department_Email ||
                          //   !departmentData.department_Phone_Number ||
                          //   errorType === 'SameName' ||
                          //   errortype === 'SameCode' ||
                          //   emailError === 'SameEmail' ||
                          //   phoneError === 'SamePhoneNumber' ||
                          //   errorType === 'EmptyName'
                          //     ? true
                          //     : false
                          // }
                          type="submit"
                          //'Submit'
                          positive
                        >
                          {
                            (
                              userLanguage[0].DEPARTMENTMASTERRegisterDepartment
                                ?.DMRB03 as any
                            )?.[`${commonStore.language.key}`]
                          }{' '}
                        </Button>
                      )}
                    </Button.Group>
                  </Form>
                )}
              </Formik>
            </Segment>
          )}
      </div>
    </>
  );
}
export default observer(DepartmentMasterForm);
